import { render, staticRenderFns } from "./categoryRulesIndex.pug?vue&type=template&id=7e8319a4&lang=pug&"
import script from "./categoryRulesIndex.ts?vue&type=script&lang=ts&"
export * from "./categoryRulesIndex.ts?vue&type=script&lang=ts&"
import style0 from "./categoryRulesIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports